import * as Yup from 'yup';

export const stepSubjectAndOvzSchema = () =>
  Yup.object().shape({
    operator: Yup.object().nullable().required('Povinné pole'),
    ovzFacility: Yup.object().nullable().required('Povinné pole'),
  });
